__turbopack_context__.v({
  "form": "ResendCode-module-scss-module__aCqRNG__form",
  "progressContainer": "ResendCode-module-scss-module__aCqRNG__progressContainer",
  "resendCode": "ResendCode-module-scss-module__aCqRNG__resendCode",
  "resendCodeButton": "ResendCode-module-scss-module__aCqRNG__resendCodeButton",
  "resendCodeText": "ResendCode-module-scss-module__aCqRNG__resendCodeText",
  "verificationCodeError": "ResendCode-module-scss-module__aCqRNG__verificationCodeError",
  "verificationTokenFormContainer": "ResendCode-module-scss-module__aCqRNG__verificationTokenFormContainer",
  "verificationTokenFormContainerError": "ResendCode-module-scss-module__aCqRNG__verificationTokenFormContainerError",
});
